
import bulkEditHeaderRow from "./bulk-edit-header-row.vue";
import BulkEditItemList from "./bulk-edit-item-list.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import BulkEditModifyForm from "./bulk-edit-modify-form.vue";
import MenuHeaderSearchField from "../menu/menu-header-search-field.vue";
export default {
  components: {
    bulkEditHeaderRow,
    BulkEditItemList,
    BulkEditModifyForm,
    MenuHeaderSearchField
  },
  data() {
    return {
      showInstruction: true,
      columns: [
        { value: "selection", text: "" },
        { value: "dish_type", text: "Dish Type" },
        { value: "item_name", text: "Item Name" },
        { value: "item_long_description", text: "Description" },
        { value: "photos", text: "Photos" },
        { value: "item_price", text: "Price" },
        { value: "delete", text: "" }
      ]
    };
  },
  computed: {
    ...mapState("menu", ["menuItems", "menuBulkEditSelection"]),
    menuList() {
      return this.menuItems.filter((el) => !el.variants?.items?.length);
    }
  },
  mounted() {
    this.getCategories();
    this.getTaxes();
    this.getTags();
    this.getLocationPrinters({});
  },
  methods: {
    ...mapActions("menu", ["getCategories", "getTaxes", "getTags"]),
    ...mapActions("restaurant", ["getLocationPrinters"])
  }
};
